import { Card, Descriptions, Divider, Text, Title } from '@bancobarigui/barihaus';
import { Proponent } from '@/services/types/inspection.types';

interface ProponentsSectionProps {
  proponents: Proponent[];
}

export function ProponentsSection({ proponents }: ProponentsSectionProps) {
  return (
    <Card className="shadow-sm">
      <Title level={4} className="mb-4">
        Proponentes
      </Title>
      {proponents && proponents.length > 0 ? (
        <div className="space-y-4">
          {proponents.map((proponent, index) => (
            <div key={index} className="border-l-4 border-blue-500 pl-4">
              <Descriptions
                column={{ xs: 1, sm: 2 }}
                size="small"
                items={[
                  {
                    key: 'name',
                    label: <Text strong>Nome</Text>,
                    children: proponent.name || '-',
                  },
                  {
                    key: 'cpfCnpj',
                    label: <Text strong>CPF/CNPJ</Text>,
                    children: proponent.cpfCnpj || '-',
                  },
                  {
                    key: 'email',
                    label: <Text strong>Email</Text>,
                    children: proponent.email || '-',
                  },
                  {
                    key: 'phones',
                    label: <Text strong>Telefones</Text>,
                    children:
                      proponent.phones && proponent.phones.length > 0
                        ? proponent.phones.map((p) => p.phoneNumber).join(', ')
                        : '-',
                  },
                ]}
              />
              {index < proponents.length - 1 && <Divider className="my-4" />}
            </div>
          ))}
        </div>
      ) : (
        <Text className="text-gray-500">Nenhum proponente cadastrado</Text>
      )}
    </Card>
  );
}
